import { createStore } from 'vuex'
import numeral from 'numeral';
export default createStore({
  state: {
    calcData: {
      "성명": "",
      "생년월일": "",
      "휴대전화": "",
      "주소지": "",
      "이메일": "",
      "무담보채무액": 0,
      "보증인": "",
      "보증채무액": 0,
      // "담보채무액": 0,
      "담보채무액_원금": 0,
      "담보채무액_이자": 0,
      "국세등체납액": 0,
      "총자산액": 0,
      "직업": "",
      "근무시작일": "",
      "근무종료일": "",
      "월평균소득액": 0,
      "월평균지출액": 0,
      "배우자여부": "N",
      "배우자소득": 0,
      "미성년자수": 0,
      "부모수": 0,
      '채무원인' : {
        생활비 : false,
        사업자금 : false,
        도박및주식 : false,
        병원비 : false,
        사기 : false,
        기타 : false
      }
    },
    calcResult : {
    },
    apiConfig : {
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        "Authorization" : "Bearer " + sessionStorage.getItem("token")
      }
    }
  },
  getters: {
    calcData: state => state.calcData,
    총채무액: (state) => {
      const value = numeral(state.calcData.무담보채무액).value() 
        + numeral(state.calcData.보증채무액).value()
        + numeral(state.calcData.담보채무액_원금).value()
        + numeral(state.calcData.국세등체납액).value();
      state.calcData.총채무액 = value;
      return numeral(value).format("0,0")
    },
    apiConfig: state => state.apiConfig
  },
  mutations: {
    updateCalcData(state, { key, value }) {      
      state.calcData[key] = value;      
    },
    updateCalcResult(state, value) {
      state.calcResult = value;
    },
    updateToken(value) {
      this.state.apiConfig.headers.Authorization = "Bearer " + value;
    }
  },
  actions: {
  },
  modules: {
  }
})
